export const styles = () => `.customSelect {
	/* Let the flex label shrink so the selected value never slides under the
	   absolutely-positioned clear/dropdown icons. */
	& .p-select-label {
		min-width: 0;
	}
}

p-select.customSelect {
	max-width: 100%;
}

/* Body-appended overlay: at least the trigger width (set inline by the
   component as \`min-width\`), free to grow via \`max-content\` to fit the longest
   one-line option, capped at the viewport so it never overflows the screen.
   The cap is the viewport rather than a fixed rem so long labels (e.g.
   legislation / organization names) still show on a single line without
   clipping; \`max-content\` keeps short dropdowns tight regardless of the cap. */
.p-select-overlay.customSelect {
	width: max-content;
	max-width: 90vw;
}

/* Keep each option on one line. With \`width: max-content\` on the overlay, an
   unbreakable option lets the panel grow to the longest label so no multi-word
   label takes a soft-wrap before using the panel's full width. */
.p-select-overlay.customSelect .p-select-option {
	white-space: nowrap;
}

`;
